module.exports = __webpack_public_path__ + "img/olga.fbe76ba4.jpg";